import { useMutation } from '@tanstack/react-query';
import { ApiDocServiceCustomFieldsRepository } from 'services/custom-fields/ApiDocServiceCustomFieldsRepository';
import type { AssignedCustomField } from 'services/custom-fields/schemas';
import { MutationKeys } from 'utils/mutationKeys';

const docServiceCustomFieldsRepository = new ApiDocServiceCustomFieldsRepository();

type MutationVariables = { id: string; type: AssignedCustomField['type']; value: unknown };

export function useUpdateCustomFieldValueMutation(contentId: string) {
  return useMutation({
    mutationKey: MutationKeys.updateCustomFieldValue,
    mutationFn: async ({ id, type, value }: MutationVariables) => {
      await docServiceCustomFieldsRepository.updateCustomField(contentId, id, type, value);
    },
  });
}
